import { Icon } from '@chakra-ui/react';

export const CustomSupportIcon = (props) => (
  <Icon viewBox="0 0 13 15" fill="none" {...props}>
    <path
      d="M5.70358 3.83372C5.47291 3.83372 5.35758 3.83372 5.25491 3.79905C4.95624 3.69839 4.84091 3.43238 4.71958 3.16572C4.58291 2.86705 4.51491 2.71772 4.50291 2.56905C4.48958 2.40105 4.52558 2.23239 4.60624 2.08839C4.71291 1.89772 4.91691 1.76438 5.08224 1.62838C5.84624 0.999718 6.22824 0.685051 6.64891 0.570385C6.98891 0.477051 7.34491 0.477051 7.68424 0.570385C8.29891 0.737718 8.81358 1.26772 9.29091 1.66038C9.53424 1.86105 9.65624 1.96172 9.72758 2.08839C9.80881 2.23486 9.84477 2.40214 9.83091 2.56905C9.81891 2.71772 9.75091 2.86705 9.61424 3.16639C9.49291 3.43305 9.37758 3.69839 9.07891 3.79905C8.97624 3.83372 8.86091 3.83372 8.63024 3.83372H5.70358ZM5.70358 10.5004C5.41291 10.5004 5.15224 10.5084 4.94824 10.7431C4.87424 10.8284 4.82291 10.9417 4.71958 11.1677C4.58358 11.4671 4.51491 11.6164 4.50291 11.7651C4.46691 12.2097 4.77091 12.4491 5.08291 12.7051C5.84624 13.3344 6.22824 13.6491 6.64958 13.7644C6.98845 13.8572 7.34604 13.8572 7.68491 13.7644C8.29891 13.5964 8.81424 13.0657 9.29091 12.6737C9.59091 12.4264 9.86491 12.1897 9.83091 11.7651C9.81891 11.6164 9.75091 11.4671 9.61424 11.1677C9.51158 10.9411 9.45958 10.8284 9.38558 10.7431C9.18158 10.5084 8.92091 10.5004 8.63091 10.5004H5.70358Z"
      stroke="currentColor"
    />
    <path
      d="M4.5 11.833C2.29067 11.833 0.5 9.74367 0.5 7.16634C0.5 4.58901 2.29067 2.49967 4.5 2.49967"
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M9.8335 2.5H10.3668C11.5448 2.5 12.5002 3.69333 12.5002 5.16667V6.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
